"use client";
import { NavBar, Footer } from "../partials";
import { FormattedMessage, GoBack, AccordionQuestions } from "../elements";
import { ContactForm } from '../forms/';
import style from '../../assets/styling/scss/contact.module.scss';

const Contact = () => {

  return (
    <>
      <NavBar />
      <main>
        <section className={style.content}>
          <GoBack />

          <h1 className={style.title}>
            <FormattedMessage id="homepage_contact_title" />
          </h1>
          <h2 className={style.subtitle}>
            <FormattedMessage id="contact_subtitle" />
          </h2>
          <p className={`${style.text} leadText`}>
            <FormattedMessage id="contact_info" />
          </p>

          <ContactForm />
        </section>

        <section className={style.content} style={{ marginTop: '-10rem' }}>

          <h1 className={style.questionTitle}>
            <FormattedMessage id="questions" />
          </h1>
          <h2>
            <FormattedMessage id="mail_question" />
          </h2>
          <div className={style.buttonWrapper}>
            <AccordionQuestions />
          </div>
        </section>
      </main>
      <Footer />
    </>
  )
}

export default Contact;

// <a
//   className={style.buttonQuestions}
//   href="mailto:info.bluecherry.io"
// >
//   <FormattedMessage id="ask_question_via_mail" />
// </a>
